// extracted by mini-css-extract-plugin
module.exports = {"expandable":"Expandable_expandable__1O2Jl"};